import React, { useState } from 'react'
import AlertDialog from '../../../../../components/AlertDialog/index.es6'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { hasAuthourity } from '../../../../../lib/access.es6'

// Approve / Reject actions for a single pending (amended) quotation. Mirrors the
// policy maker-checker UX: an approve confirmation and a reject confirmation.
// The reject endpoint takes no reason, so reject is a plain confirmation. The
// server attaches the quotation to its policy on confirm.
const QuotationDecision = props => {
  const [showApprove, setShowApprove] = useState(false)
  const [showReject, setShowReject] = useState(false)

  const canDecide = hasAuthourity('APPROVE_POLICY')
  const quotationNumber = props.quote.quotation_number || ''

  if (!canDecide) {
    return (
      <span style={{ fontSize: '12px', color: '#8F191C' }}>
        You do not have permission to decide this quotation.
      </span>
    )
  }

  return (
    <>
      <ButtonInc onClick={() => setShowApprove(true)}>Approve</ButtonInc>
      <ButtonInc
        style={{ background: '#8F191C', marginLeft: '8px' }}
        onClick={() => setShowReject(true)}
      >
        Reject
      </ButtonInc>

      <AlertDialog
        warning
        show={showApprove}
        size="sm"
        title={`Approve quotation ${quotationNumber}?`}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => setShowApprove(false)}
        onCancel={() => {
          setShowApprove(false)
          props.onDecision(props.quote.guid, 'confirm')
        }}
        confirmBtnText="Cancel"
        showCancel
        showConfirm
        cancelBtnText="Approve"
        confirmBtnCssClass
      />

      <AlertDialog
        warning
        show={showReject}
        size="sm"
        title={`Reject quotation ${quotationNumber}?`}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => setShowReject(false)}
        onCancel={() => {
          setShowReject(false)
          props.onDecision(props.quote.guid, 'reject')
        }}
        confirmBtnText="Cancel"
        showCancel
        showConfirm
        cancelBtnText="Reject"
        confirmBtnCssClass
      />
    </>
  )
}

export default QuotationDecision
